import React, { FC, ReactNode } from 'react';
import Footer from './Footer/Footer';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import Header from './Header/index';
import { AnimatePresence, motion } from 'framer-motion';
import { ToastContainer } from 'react-toastify';
import { ParallaxProvider } from 'react-scroll-parallax';

// Importing the SVG as a URL

interface RootProps {
  children?: ReactNode;
}

const Root: FC<RootProps> = ({ children }) => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <div className="relative flex flex-col min-h-screen text-white bg-transparent overflow-x-hidden">
      <AnimatePresence>
        <ParallaxProvider>
          {/* Give each direct child a unique "key" */}
          <Header key="header" />

          {/* MAIN CONTENT */}
          <div key="main-content" className="flex-grow relative">
            {children}
          </div>

          {pathname !== '/order' && (
            <div className="fixed bottom-2 right-0 -translate-x-1/2 md:hidden z-50">
              {/* Row that places the Order button flush to the right */}
              <motion.a
                href="/order"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="
                bg-maroon text-white font-prosto 
                text-sm font-regular rounded-full
                px-12 py-3
              "
              >
                Order Online
              </motion.a>
            </div>
          )}

          <Footer key="footer" />

          <ToastContainer
            key="toast"
            position="top-right"
            className="mt-36"
            autoClose={2500}
          />

          <ScrollRestoration
            key="scroll-restoration"
            getKey={(location) => location.pathname}
          />
        </ParallaxProvider>
      </AnimatePresence>
    </div>
  );
};

export default Root;
